var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100"},[(_vm.is_load)?_c('div',{staticClass:"w-100 h-100 d-flex align-items-center justify-content-center"},[_c('loader')],1):[(_vm.page_design_type === 'WIDE_VIEW')?_c('PosWideLayout'):_c('PosMobileLayout')]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54ad538d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/hotel/concierge/pos/index.vue
// module id = null
// module chunks = 